import React from "react";

const TlsInactiveTemplate = () => {
  return (
    <main
      className="container d-flex align-items-center justify-content-center py-5 inter"
      style={{ minHeight: "100vh" }}
    >
      <section className="text-center" style={{ maxWidth: "760px" }}>
        <p>
          The Loan Store (TLS) is now Averra Financial Inc., and Calque is still
          Calque. For more information on TLS's offerings, please go to their{" "}
          <a
            href="https://averrafi.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            new Averra website
          </a>
          .
        </p>
        <p>
          For more information on Calque's Trade-In Mortgage, please see our
          main corporate website (
          <a
            href="https://www.calqueinc.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.calqueinc.com
          </a>
          ).
        </p>
      </section>
    </main>
  );
};

export default TlsInactiveTemplate;
